(function(){
"use strict";

var root=document.querySelector(".ptiq-mock");
if(!root)return;

var ACTIVE_KEY="ptiq_mock_test_active_v1";
var HISTORY_KEY="ptiq_mock_test_history_v1";
var COMPLETE_KEY="ptiq_mock_test_complete";
var LAST_RESULT_KEY="ptiq_mock_test_last_result_v1";

var images={
engine:root.dataset.engineImage,
driver:root.dataset.driverImage,
coupling:root.dataset.couplingImage,
cab:root.dataset.inCabImage
};

function q(category,type,text,options,answer,explanation,image){
return {category:category,type:type,text:text,options:options,answer:answer,explanation:explanation,image:image||""};
}

var bank=[
q("Engine Compartment","knowledge","What is the safest description of an acceptable engine-oil check?",["Oil is visible somewhere on the dipstick","Oil level is within the safe range and no visible leaks are present","The oil cap is warm","The engine has recently been started"],1,"The inspection should confirm a safe level and check for leaks."),
q("Engine Compartment","knowledge","Which condition on a steering linkage is unsafe?",["Secure mounting","Missing hardware","No visible bends","Tight connections"],1,"Missing linkage hardware can compromise steering control."),
q("Engine Compartment","knowledge","What should be checked on visible engine belts?",["Color and brand","Cracks, fraying, wear, and tension","Brake lining thickness","Air-tank pressure"],1,"Belts should be secure and free of cracks, fraying, and excessive wear."),
q("Engine Compartment","knowledge","Which component builds compressed air for the brake system?",["Alternator","Air compressor","Coolant reservoir","Power steering reservoir"],1,"The air compressor builds system pressure for air brakes."),
q("Engine Compartment","visual","Which component converts air pressure into mechanical brake movement?",["Brake chamber","Shock absorber","Tie rod","Hub seal"],0,"The brake chamber converts air pressure into pushrod movement.",images.engine),
q("Engine Compartment","knowledge","What is the main purpose of a shock absorber?",["Carry all vehicle weight","Control suspension bouncing","Build air pressure","Hold wheel lubricant"],1,"A shock absorber dampens suspension movement."),
q("Engine Compartment","knowledge","Which coolant-reservoir condition is acceptable?",["Loose cap and low level","Adequate level, secure cap, no leaks","Cracked tank with no active drip","Reservoir touching a hot belt"],1,"Coolant level, mounting, cap, and leaks should all be checked."),
q("Walkaround","knowledge","What should be checked between dual tires?",["Only tread color","Debris, spacing, and tire contact","Fuel level","Mirror adjustment"],1,"Debris and tire contact between duals can create unsafe damage."),
q("Walkaround","knowledge","Which fuel-tank condition is acceptable?",["Loose mounting strap","Missing cap seal","Secure straps and no visible leaks","Fuel residue around the cap"],2,"The tank, straps, cap, and lines should be secure and leak-free."),
q("Walkaround","knowledge","What can rust trails around a lug nut indicate?",["Proper torque","Possible looseness or movement","Correct tire pressure","A sealed hub"],1,"Rust trails or shiny metal can indicate movement."),
q("Walkaround","visual","Which component retains lubricant inside the wheel hub?",["Hub seal","Valve stem","Lug nut","Brake lining"],0,"The hub seal retains lubricant and helps keep contaminants out.",images.driver),
q("Walkaround","knowledge","Why are frame rails and crossmembers inspected?",["To identify fuel grade","To find cracks, bends, broken welds, or missing hardware","To adjust mirrors","To build air pressure"],1,"They are structural components and must be intact and secure."),
q("Walkaround","knowledge","Which tire condition requires removal from service or immediate attention?",["Adequate tread","Proper inflation","Exposed cord","Secure valve stem"],2,"Exposed cord indicates serious tire damage."),
q("Walkaround","knowledge","Which statement best describes a safe rim inspection?",["No cracks, bends, or unsafe repairs","Clean paint only","Matching color","Warm after driving"],0,"Rims must be structurally sound."),
q("Coupling and Trailer","knowledge","Where must fifth-wheel locking jaws close?",["Around the kingpin head","Around the kingpin shank","Around the apron edge","Around the release handle"],1,"The jaws must close around the kingpin shank."),
q("Coupling and Trailer","knowledge","What does a visible gap between the trailer apron and fifth wheel suggest?",["Correct coupling","Possible improper coupling","Correct lubrication","Proper trailer height"],1,"The apron should rest flat on the fifth wheel with no gap."),
q("Coupling and Trailer","visual","Which fittings connect the tractor air lines to the trailer?",["Glad hands","Electrical pigtail","Drain valves","Slider pins"],0,"Glad hands connect the trailer service and emergency air lines.",images.coupling),
q("Coupling and Trailer","knowledge","What must be verified on sliding tandem locking pins?",["At least one pin is engaged","Every required pin is fully engaged","The release handle is painted","The trailer is empty"],1,"Every required locking pin must be fully engaged."),
q("Coupling and Trailer","knowledge","What should happen to landing gear before travel?",["Remain partly lowered","Be fully raised with the handle secured","Touch the tractor frame","Remain unlocked"],1,"Landing gear should be fully raised and secured."),
q("Coupling and Trailer","knowledge","Which connection carries trailer electrical power and light signals?",["Emergency air line","Electrical pigtail","Service air line","Fifth-wheel release handle"],1,"The electrical pigtail powers trailer electrical circuits."),
q("Coupling and Trailer","knowledge","What should be checked on air and electrical lines?",["Only color","Support, secure connection, damage, leaks, and dragging","Trailer weight only","Paint condition"],1,"Lines should be connected, supported, undamaged, and not dragging."),
q("Coupling and Trailer","knowledge","What is the purpose of the kingpin?",["Support landing gear","Provide the connection captured by fifth-wheel jaws","Supply trailer electricity","Adjust tandem position"],1,"The kingpin is the trailer coupling point captured by the jaws."),
q("In-Cab","knowledge","Which emergency equipment is commonly required?",["Fire extinguisher and warning triangles","Spare steering wheel","Extra mirror only","Coolant hose only"],0,"Common required emergency equipment includes a fire extinguisher and warning devices."),
q("In-Cab","knowledge","What should warning indicators normally do during startup?",["Never illuminate","Self-test and then extinguish as appropriate","Stay on continuously","Flash randomly"],1,"Indicators commonly illuminate for self-test and then return to normal."),
q("In-Cab","knowledge","Which items are part of the visibility check?",["Windshield, mirrors, wipers, and washers","Fuel straps only","Kingpin and jaws","Hub seals only"],0,"Visibility equipment must be clean, secure, and functional."),
q("In-Cab","visual","Which gauges display pressure in separate air circuits?",["Primary and secondary air gauges","Fuel and DEF gauges","Oil and coolant gauges","Speedometer and tachometer"],0,"Primary and secondary gauges show air pressure in separate systems.",images.cab),
q("In-Cab","knowledge","What should be checked on the seat belt?",["Color only","Mounting, cuts, fraying, and latch function","Air pressure","Tread depth"],1,"The restraint must be secure, undamaged, and functional."),
q("In-Cab","knowledge","Which control commonly applies the tractor parking brakes?",["Yellow parking-brake control","Red trailer air-supply control","Headlight switch","Air horn valve"],0,"The yellow push-pull control commonly operates tractor parking brakes."),
q("In-Cab","knowledge","Which control commonly supplies air to the trailer?",["Yellow parking-brake control","Red trailer air-supply control","Wiper control","Differential lock"],1,"The red control commonly manages trailer air supply."),
q("Air Brakes","knowledge","What is the purpose of the low-air warning?",["Warn before pressure becomes dangerously low","Show fuel level","Test headlights","Release the fifth wheel"],0,"The low-air warning alerts the driver before pressure becomes unsafe."),
q("Air Brakes","knowledge","What is measured during an applied leak check?",["Air-pressure loss while the service brake is applied","Fuel leakage","Steering play","Coolant temperature"],0,"The test measures pressure loss while brakes are held applied."),
q("Air Brakes","knowledge","Why must exact air-brake thresholds be verified?",["Every vehicle uses identical numbers","Requirements may vary by vehicle, state, and test path","Thresholds are optional","Only trailer type matters"],1,"Exact limits should not be presented as universal."),
q("Air Brakes","knowledge","What should happen during a low-speed service-brake test?",["The vehicle stops smoothly without pulling","The vehicle accelerates","The vehicle pulls sharply","The trailer releases"],0,"Service brakes should stop the vehicle smoothly and straight."),
q("Air Brakes","knowledge","When should the low-air warning activate?",["After spring brakes fully apply","Before pressure falls below the verified required threshold","Only after engine shutdown","At any random pressure"],1,"The warning must activate before pressure becomes critically low."),
q("Air Brakes","knowledge","What should happen as air pressure continues to decrease during a spring-brake test?",["Spring brakes activate within the verified range","Headlights turn off","The fifth wheel releases","Coolant level rises"],0,"Spring brakes should activate within the verified pressure range."),
q("Air Brakes","knowledge","What does governor cut-out indicate?",["The compressor stopped building at the proper upper range","The brakes failed","The trailer disconnected","The engine oil is low"],0,"Cut-out indicates the governor has stopped compressor loading at the proper upper range."),
q("Air Brakes","visual","Which dashboard area is used to monitor primary and secondary air pressure?",["Air-pressure gauges","Fuel gauge only","Speedometer only","Radio display"],0,"The air-pressure gauges show system pressure.",images.cab),
q("Air Brakes","knowledge","Why should the vehicle be secured during stationary air-brake checks?",["To prevent unintended movement","To raise tire pressure","To cool the engine","To unlock the trailer"],0,"Stationary brake tests must be performed with the vehicle secured."),
q("General Inspection","knowledge","Which inspection wording is strongest?",["Looks okay","Properly mounted and secure, not cracked, bent, or broken","Probably works","It was fine yesterday"],1,"Specific condition and security language is clearer and safer."),
q("General Inspection","knowledge","What should a trainee do when an exact limit is uncertain?",["Invent a number","Verify the official requirement before memorizing it","Skip the system","Use another vehicle's value"],1,"Verified requirements should replace guesses."),
q("General Inspection","knowledge","Why is a consistent inspection sequence useful?",["It reduces missed components","It changes legal requirements","It removes the need for practice","It guarantees passing"],0,"A repeatable sequence reduces omissions."),
q("General Inspection","knowledge","What is the best response to a component that is loose, damaged, or leaking?",["Ignore it if the vehicle starts","Identify it as unsafe and address it before operation","Paint over it","Only photograph it"],1,"Unsafe defects should be identified and corrected."),
q("General Inspection","visual","Which training area contains the fifth wheel, kingpin, air lines, and pigtail?",["Coupling area","In-cab area","Engine oil system only","Rear door area"],0,"Those components are located in the coupling area.",images.coupling)
];

var state={session:null,timerId:null,selectedChoice:null};

var els={
setup:root.querySelector("[data-setup]"),
count:root.querySelector("[data-count]"),
pace:root.querySelector("[data-pace]"),
mix:root.querySelector("[data-mix]"),
agree:root.querySelector("[data-agree]"),
start:root.querySelector("[data-start]"),
resume:root.querySelector("[data-resume]"),
duration:root.querySelector("[data-duration-copy]"),
test:root.querySelector("[data-test]"),
results:root.querySelector("[data-results]"),
progressCopy:root.querySelector("[data-progress-copy]"),
progressFill:root.querySelector("[data-progress-fill]"),
timerWrap:root.querySelector("[data-timer-wrap]"),
timer:root.querySelector("[data-timer]"),
category:root.querySelector("[data-category]"),
type:root.querySelector("[data-type]"),
answerState:root.querySelector("[data-answer-state]"),
visual:root.querySelector("[data-visual]"),
image:root.querySelector("[data-image]"),
question:root.querySelector("[data-question]"),
answers:root.querySelector("[data-answers]"),
skip:root.querySelector("[data-skip]"),
next:root.querySelector("[data-next]"),
answered:root.querySelector("[data-answered]"),
unanswered:root.querySelector("[data-unanswered]"),
locked:root.querySelector("[data-locked]"),
submitModal:root.querySelector("[data-submit-modal]"),
submitCopy:root.querySelector("[data-submit-copy]")
};

function shuffle(arr){
var a=arr.slice();
for(var i=a.length-1;i>0;i--){
var j=Math.floor(Math.random()*(i+1));
var t=a[i];a[i]=a[j];a[j]=t;
}
return a;
}

function saveActive(){
try{
if(state.session)localStorage.setItem(ACTIVE_KEY,JSON.stringify(state.session));
else localStorage.removeItem(ACTIVE_KEY);
}catch(e){}
}

function loadActive(){
try{
var saved=JSON.parse(localStorage.getItem(ACTIVE_KEY)||"null");
if(saved&&saved.questions&&saved.questions.length&&!saved.completedAt){
state.session=saved;
return true;
}
}catch(e){}
return false;
}

function formatTime(totalSeconds){
totalSeconds=Math.max(0,Math.floor(totalSeconds));
var minutes=Math.floor(totalSeconds/60);
var seconds=totalSeconds%60;
return String(minutes).padStart(2,"0")+":"+String(seconds).padStart(2,"0");
}

function categoryStats(){
var stats={};
state.session.questions.forEach(function(item,index){
if(!stats[item.category])stats[item.category]={correct:0,total:0};
stats[item.category].total++;
var answer=state.session.answers[index];
if(answer&&answer.correct)stats[item.category].correct++;
});
return stats;
}

function answeredCount(){
return state.session.answers.filter(function(a){return a&&a.choice!==null}).length;
}

function lockedCount(){
return state.session.locked.filter(Boolean).length;
}

function remainingSeconds(){
if(!state.session)return 0;
return Math.max(0,Math.ceil((state.session.endsAt-Date.now())/1000));
}

function buildPool(count,mix){
var knowledge=bank.filter(function(x){return x.type==="knowledge"});
var visual=bank.filter(function(x){return x.type==="visual"});
var result=[];
if(mix==="knowledge"){
result=shuffle(knowledge).slice(0,count);
}else if(mix==="visual"){
var visualTarget=Math.min(visual.length,Math.max(4,Math.round(count*.3)));
result=shuffle(visual).slice(0,visualTarget).concat(shuffle(knowledge).slice(0,count-visualTarget));
result=shuffle(result);
}else{
var visualTarget=Math.min(visual.length,Math.max(3,Math.round(count*.18)));
result=shuffle(visual).slice(0,visualTarget).concat(shuffle(knowledge).slice(0,count-visualTarget));
result=shuffle(result);
}
if(result.length<count){
var extras=shuffle(bank.filter(function(x){return result.indexOf(x)===-1}));
result=result.concat(extras.slice(0,count-result.length));
}
return result.slice(0,count);
}

function updateDuration(){
var count=parseInt(els.count.value,10)||30;
var pace=parseInt(els.pace.value,10)||60;
var total=count*pace;
els.duration.textContent=Math.round(total/60)+" minutes";
}

function startTest(){
var count=parseInt(els.count.value,10)||30;
var pace=parseInt(els.pace.value,10)||60;
var mix=els.mix.value||"balanced";
var totalSeconds=count*pace;
var questions=buildPool(count,mix);

state.session={
version:1,
startedAt:Date.now(),
endsAt:Date.now()+totalSeconds*1000,
durationSeconds:totalSeconds,
questionCount:questions.length,
paceSeconds:pace,
mix:mix,
index:0,
questions:questions,
answers:new Array(questions.length).fill(null),
locked:new Array(questions.length).fill(false),
skipped:new Array(questions.length).fill(false),
completedAt:null,
submissionReason:null
};
state.selectedChoice=null;
saveActive();
showTest();
}

function showTest(){
els.setup.hidden=true;
els.results.hidden=true;
els.test.hidden=false;
renderQuestion();
startTimer();
setTimeout(function(){
root.querySelector("#mock-test").scrollIntoView({behavior:"smooth",block:"start"});
},20);
}

function startTimer(){
stopTimer();
updateTimer();
state.timerId=setInterval(updateTimer,500);
}

function stopTimer(){
if(state.timerId){
clearInterval(state.timerId);
state.timerId=null;
}
}

function updateTimer(){
if(!state.session)return;
var left=remainingSeconds();
els.timer.textContent=formatTime(left);
els.timerWrap.classList.toggle("is-warning",left<=300&&left>60);
els.timerWrap.classList.toggle("is-danger",left<=60);
if(left<=0){
stopTimer();
submitTest("time_expired");
}
}

function renderAnswers(){
var item=state.session.questions[state.session.index];
els.answers.innerHTML="";
item.options.forEach(function(label,index){
var button=document.createElement("button");
button.type="button";
button.className="ptiq-mock-answer"+(state.selectedChoice===index?" is-selected":"");
button.textContent=label;
button.addEventListener("click",function(){
state.selectedChoice=index;
els.next.disabled=false;
els.answerState.textContent="Answer selected";
els.answerState.className="is-selected";
renderAnswers();
});
els.answers.appendChild(button);
});
}

function renderStatus(){
var total=state.session.questions.length;
var answered=answeredCount();
els.answered.textContent=answered;
els.unanswered.textContent=total-answered;
els.locked.textContent=lockedCount();
}

function renderQuestion(){
var s=state.session;
if(!s)return;
if(s.index>=s.questions.length){
openSubmit();
return;
}
var item=s.questions[s.index];
state.selectedChoice=null;
els.progressCopy.textContent="Question "+(s.index+1)+" of "+s.questions.length;
els.progressFill.style.width=Math.round((s.index/s.questions.length)*100)+"%";
els.category.textContent=item.category.toUpperCase();
els.type.textContent=item.type==="visual"?"VISUAL":"KNOWLEDGE";
els.answerState.textContent="Unanswered";
els.answerState.className="";
els.visual.hidden=!item.image;
if(item.image){
els.image.src=item.image;
els.image.alt=item.category+" training image";
}
els.question.textContent=item.text;
els.next.disabled=true;
els.next.textContent=s.index===s.questions.length-1?"Lock Answer & Submit →":"Lock Answer & Continue →";
renderAnswers();
renderStatus();
saveActive();
}

function lockAndContinue(){
if(state.selectedChoice===null)return;
var s=state.session;
var item=s.questions[s.index];
s.answers[s.index]={
choice:state.selectedChoice,
correct:state.selectedChoice===item.answer,
answeredAt:Date.now()
};
s.locked[s.index]=true;
s.skipped[s.index]=false;
s.index++;
state.selectedChoice=null;
saveActive();
if(s.index>=s.questions.length)openSubmit();
else renderQuestion();
}

function skipAndContinue(){
var s=state.session;
s.answers[s.index]=null;
s.locked[s.index]=true;
s.skipped[s.index]=true;
s.index++;
state.selectedChoice=null;
saveActive();
if(s.index>=s.questions.length)openSubmit();
else renderQuestion();
}

function openSubmit(){
var total=state.session.questions.length;
var unanswered=total-answeredCount();
els.submitCopy.textContent=unanswered?
"You have "+unanswered+" unanswered question"+(unanswered===1?"":"s")+". Unanswered questions count as incorrect.":
"Every question has an answer. Submit now to see your results.";
els.submitModal.hidden=false;
}

function closeSubmit(){
els.submitModal.hidden=true;
if(state.session.index>=state.session.questions.length){
var firstUnlocked=state.session.locked.findIndex(function(x){return !x});
if(firstUnlocked>=0){
state.session.index=firstUnlocked;
renderQuestion();
}
}
}

function submitTest(reason){
if(!state.session||state.session.completedAt)return;
stopTimer();
els.submitModal.hidden=true;
state.session.completedAt=Date.now();
state.session.submissionReason=reason||"manual";
saveActive();

var total=state.session.questions.length;
var correct=state.session.answers.filter(function(a){return a&&a.correct}).length;
var answered=answeredCount();
var unanswered=total-answered;
var percent=Math.round(correct/total*100);
var used=Math.min(state.session.durationSeconds,Math.max(0,Math.round((state.session.completedAt-state.session.startedAt)/1000)));
var stats=categoryStats();

var result={
completedAt:state.session.completedAt,
startedAt:state.session.startedAt,
scorePercent:percent,
correct:correct,
incorrect:total-correct,
unanswered:unanswered,
total:total,
timeUsedSeconds:used,
durationSeconds:state.session.durationSeconds,
submissionReason:state.session.submissionReason,
categoryStats:stats
};

try{
localStorage.setItem(LAST_RESULT_KEY,JSON.stringify(result));
localStorage.setItem(COMPLETE_KEY,"1");
var history=JSON.parse(localStorage.getItem(HISTORY_KEY)||"[]");
history.unshift(result);
localStorage.setItem(HISTORY_KEY,JSON.stringify(history.slice(0,20)));
localStorage.removeItem(ACTIVE_KEY);
}catch(e){}

showResults(result);
}

function showResults(result){
els.test.hidden=true;
els.setup.hidden=true;
els.results.hidden=false;

var score=result.scorePercent;
root.querySelector("[data-score]").textContent=score+"%";
root.querySelector(".ptiq-mock-results__score").style.background=
"radial-gradient(circle at center,#0b1c27 58%,transparent 60%),conic-gradient(var(--cyan) 0 "+score+"%,rgba(255,255,255,.08) "+score+"% 100%)";

root.querySelector("[data-results-title]").textContent=
score>=90?"Excellent pressure test.":
score>=80?"Strong mock-test result.":
score>=70?"Useful result with clear review areas.":
"This simulation exposed important weak areas.";

root.querySelector("[data-results-copy]").textContent=
"The test was scored from first answers only. Review the category breakdown and every missed question before relying on this result.";

root.querySelector("[data-correct]").textContent=result.correct;
root.querySelector("[data-incorrect]").textContent=result.incorrect;
root.querySelector("[data-unanswered-result]").textContent=result.unanswered;
root.querySelector("[data-time-used]").textContent=formatTime(result.timeUsedSeconds);

var rows=Object.keys(result.categoryStats).map(function(name){
var x=result.categoryStats[name];
return {name:name,correct:x.correct,total:x.total,pct:Math.round(x.correct/x.total*100)};
}).sort(function(a,b){return a.pct-b.pct});

root.querySelector("[data-breakdown]").innerHTML=rows.map(function(row){
return '<div class="ptiq-breakdown-row"><span>'+row.name+'</span><i><b style="width:'+row.pct+'%"></b></i><strong>'+row.correct+'/'+row.total+' · '+row.pct+'%</strong></div>';
}).join("");

var review=root.querySelector("[data-review-list]");
review.hidden=true;
review.innerHTML=state.session.questions.map(function(item,index){
var answer=state.session.answers[index];
var isCorrect=!!(answer&&answer.correct);
var userText=answer?item.options[answer.choice]:"Unanswered";
return '<article class="ptiq-review-item">'+
'<small>QUESTION '+(index+1)+' · '+item.category.toUpperCase()+'</small>'+
'<h4>'+item.text+'</h4>'+
'<p class="'+(isCorrect?"is-good":"is-bad")+'"><strong>Your answer:</strong> '+userText+'</p>'+
'<p><strong>Correct answer:</strong> '+item.options[item.answer]+'</p>'+
'<p>'+item.explanation+'</p>'+
'</article>';
}).join("");

setTimeout(function(){
els.results.scrollIntoView({behavior:"smooth",block:"start"});
},20);
}

function resetForNew(){
stopTimer();
state.session=null;
state.selectedChoice=null;
try{localStorage.removeItem(ACTIVE_KEY)}catch(e){}
els.results.hidden=true;
els.test.hidden=true;
els.setup.hidden=false;
els.agree.checked=false;
els.start.disabled=true;
updateDuration();
els.setup.scrollIntoView({behavior:"smooth",block:"start"});
}

root.querySelector("[data-open-setup]").addEventListener("click",function(){
els.setup.hidden=false;
els.test.hidden=true;
els.results.hidden=true;
els.setup.scrollIntoView({behavior:"smooth",block:"start"});
});

root.querySelector("[data-close-setup]").addEventListener("click",function(){
els.setup.hidden=true;
});

els.count.addEventListener("change",updateDuration);
els.pace.addEventListener("change",updateDuration);
els.agree.addEventListener("change",function(){
els.start.disabled=!els.agree.checked;
});
els.start.addEventListener("click",startTest);
els.resume.addEventListener("click",showTest);
els.next.addEventListener("click",lockAndContinue);
els.skip.addEventListener("click",skipAndContinue);
root.querySelector("[data-submit-open]").addEventListener("click",openSubmit);
root.querySelector("[data-cancel-submit]").addEventListener("click",closeSubmit);
root.querySelector("[data-confirm-submit]").addEventListener("click",function(){submitTest("manual")});
root.querySelector("[data-new-test]").addEventListener("click",resetForNew);

root.querySelector("[data-toggle-review]").addEventListener("click",function(event){
var list=root.querySelector("[data-review-list]");
list.hidden=!list.hidden;
event.currentTarget.textContent=list.hidden?"Show Review":"Hide Review";
});

window.addEventListener("beforeunload",saveActive);

updateDuration();
var hasActive=loadActive();
els.resume.hidden=!hasActive;
if(hasActive&&remainingSeconds()<=0){
submitTest("time_expired");
}
})();